/**
 * Convert Uint32 to string
 *
 * @see https://voltaire.tevm.sh/primitives/uint32 for Uint32 documentation
 * @since 0.0.0
 * @param {import('./Uint32Type.js').Uint32Type} uint - Uint32 value to convert
 * @returns {string} decimal string representation
 * @throws {never}
 * @example
 * ```javascript
 * import * as Uint32 from './primitives/Uint32/index.js';
 * const value = Uint32.from(255);
 * const str = Uint32.toString(value); // "255"
 * ```
 */
// biome-ignore lint/suspicious/noShadowRestrictedNames: toString is standard API name
export function toString(uint) {
	return uint.toString();
}
